import React from "react";
export var TSpan = function (props) {
  return (
    /*#__PURE__*/
    // @ts-expect-error FIXME: "id cannot be a number"
    React.createElement("tspan", props)
  );
};
//# sourceMappingURL=tspan.js.map